import Icon from '../components/Icon.vue'

Icon.register({
  mask: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320.7 64c449.1 0 348.3 384 158.5 384-39.9 0-77.5-20.7-101.4-55.9l-25.7-37.8c-15.7-23-47-23-62.6 0l-25.7 37.8c-24 35.2-61.5 55.9-101.4 55.9-199.1 0-284.1-384 158.5-384zM184 308.4c41.1 0 67.8-25.7 80.1-41.1 5.2-6.5 5.2-16.1 0-22.6-12.3-15.4-39-41-80.1-41s-67.8 25.7-80.1 41c-5.2 6.5-5.2 16.1 0 22.6 12.3 15.4 39 41.1 80.1 41.1zM456 308.4c41.1 0 67.8-25.7 80.1-41.1 5.2-6.5 5.2-16.1 0-22.6-12.3-15.4-39-41-80.1-41s-67.8 25.7-80.1 41c-5.2 6.5-5.2 16.1 0 22.6 12.3 15.4 39 41.1 80.1 41.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mask.js
// module id = 1555
// module chunks = 0